export enum VehicleSearchTypeEnum {
    classSearch = 1,
    MakeModelYearSearch=2,
    vehicleSearch=3,
  }
